import { Controller } from "@hotwired/stimulus"
import { fill, money, number, read } from "../../lib/format"

// A monthly price from cost and target margin, and what that price needs in
// customers to reach a revenue target under a given churn.
export default class extends Controller {
  static targets = ["cost", "margin", "target", "churn", "price", "customers", "replace", "ltv"]
  static values = { messages: Object }

  connect() { this.compute() }

  compute() {
    const cost = read(this.costTarget)
    const margin = Math.min(read(this.marginTarget), 99) / 100
    const churn = Math.min(read(this.churnTarget), 100) / 100
    const price = cost > 0 ? cost / (1 - margin) : 0
    const customers = price > 0 ? Math.ceil(read(this.targetTarget) / price) : 0
    const lifetime = churn > 0 ? 1 / churn : Infinity

    this.priceTarget.textContent = price > 0 ? money(price) : "—"
    this.customersTarget.textContent = price > 0 ? number(customers) : "—"
    this.replaceTarget.textContent = price > 0 ? number(Math.ceil(customers * churn)) : "—"
    this.ltvTarget.innerHTML = price > 0 && Number.isFinite(lifetime)
      ? `${money(price * lifetime)} <small>${fill(this.messagesValue.months, { count: number(lifetime, 0) })}</small>`
      : (price > 0 ? this.messagesValue.no_churn : "—")
  }
}
